<template>
  <div style="position: fixed; top: 145px; right: 1rem; z-index: 3">
    <a class="btn btn-primary" :href="'/videos/' + getVideo($route.name)" target="_blank">
      <i class="bi bi-play-btn-fill"></i> Hilfe
    </a>
  </div>
</template>

<script>
export default {
  setup() {
    const getVideo = (name) => {
      switch (name) {
        case 'layout':
        case 'formatbinding':
        case 'cover':
          return 'designer';
        case 'content':
          return 'content';
        case 'checkout':
          return 'ordering';
      }
    };

    return {
      getVideo,
    };
  },
};
</script>

<style lang="scss" scoped></style>
